import React, {FC, PropsWithChildren, ReactNode} from 'react';
import styled from 'styled-components';

import {fontSizes, fontWeights} from '../../../libs/shared/ui/src/styles/fontStyles';
import {StartGuideProgressBar} from '../startGuide/startGuideProgressBar';

/*
 * Props.
 */

interface OnboardingGuideProps {
  progress: number;
  title: ReactNode;
  description?: ReactNode;
  className?: string;
}

// TODO-ONBOARD: Need to fix the styling, some of it was taken from setupGuide.tsx
const StyledOnboardingGuideDiv = styled.div`
  display: flex;
  flex-direction: column;
  align-content: center;
  flex-wrap: wrap;
`;

const StyledHeaderDiv = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 16px;
  width: 100%;
`;

const StyledTitleSpan = styled.span`
  font-size: ${fontSizes.veryLarge};
  font-weight: ${fontWeights.semibold};
  color: ${(p) => p.theme.greys.shade90};
  line-height: 24px;
`;

const StyledDescriptionSpan = styled.span`
  font-size: ${fontSizes.medium};
  color: ${(p) => p.theme.greys.shade80};
  line-height: 22px;
`;

const StyledTasksDiv = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  margin-top: 20px;
`;

/*
 * Component.
 */

export const OnboardingGuide: FC<PropsWithChildren<OnboardingGuideProps>> = (props) => {
  const {children, progress} = props;

  return (
    <StyledOnboardingGuideDiv className={props.className}>
      <StyledHeaderDiv>
        <StyledTitleSpan>{props.title}</StyledTitleSpan>
        <StyledDescriptionSpan>{props.description}</StyledDescriptionSpan>
      </StyledHeaderDiv>

      <StartGuideProgressBar completionPercentage={progress} />

      <StyledTasksDiv>{children}</StyledTasksDiv>
    </StyledOnboardingGuideDiv>
  );
};
